import "core-js/modules/es.array.push.js";
import debounce from "debounce";
import VirtualList from "vue-virtual-scroll-list";
import { recursiveSearch } from "@utils/DataUtilities.js";
import { transitionDuration } from "@utils/DOMUtilities.js";
import Item from "./SearchModal.Item.vue";
export default {
  components: {
    "virtual-list": VirtualList
  },
  props: {
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    inputClasses: {
      type: String,
      default: ""
    },
    inputIconClasses: {
      type: String,
      default: ""
    },
    resultClasses: {
      type: String,
      default: ""
    },
    searchable: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: "contains"
    },
    smartSearch: {
      type: Boolean,
      default: true
    },
    caseSensitive: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      query: "",
      active: false,
      backdrop: null,
      itemComponent: Item,
      results: [],
      prev: ""
    };
  },
  mounted() {
    let context = this;
    window.addEventListener("resize", context.setResultsHeight);
    document.addEventListener("keyup", e => {
      if (event.key === "Escape") {
        context.$refs.input.blur();
        if (e.target != context.$refs.input || context.query == "") {
          context.active = false;
        }
      }
    });
  },
  computed: {
    // results: {
    //     cache: false,
    //     get() {
    //         return recursiveSearch({
    //             data: this.$store.getters.searchData(),
    //             query: this.query,
    //             searchable: this.searchable,
    //             mode: this.mode,
    //             smartSearcH: this.smartSearch,
    //             caseSensitive: this.caseSensitive
    //         });
    //     }
    // },
  },
  watch: {
    active(val) {
      if (val && this.overlay) {
        this.$refs.vList.scrollToIndex(0);
        if (this.results.length == 0) this.results = this.$store.getters.searchData;
        this.query = this.prev;
        setTimeout(() => {
          this.$refs.input.select();
        }, 1);
        this.$refs.wrapper.style.zIndex = "1050";
        this.backdrop = document.createElement("div");
        this.backdrop.classList.add("modal-backdrop", "fade");
        this.backdrop.addEventListener("click", () => {
          this.active = false;
        });
        document.querySelector("main").insertAdjacentElement("beforeend", this.backdrop);
        this.$refs.results.style.top = "100%";
        this.$refs.results.style.top = "100%";
        setTimeout(() => {
          document.body.classList.add("overflow-hidden");
          this.$refs.results.style.opacity = "1";
          this.backdrop.classList.add("show");

          // set ScrollPosition
          const yOffset = -32;
          const y = this.$refs.input.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({
            top: y,
            behavior: "smooth"
          });
          this.setResultsHeight(val);
          setTimeout(() => {
            this.$refs.results.classList.add("overflow-auto");
            this.$refs.results.classList.remove("overflow-hidden");
          }, transitionDuration(this.$refs.results) + 100);
        }, 1);
      } else {
        this.prev = this.query;
        this.query = "";
        if (this.backdrop && this.backdrop.classList) {
          this.backdrop.classList.remove("show");
          this.$refs.results.style.opacity = 0;
          this.$refs.results.style.top = "";
          document.body.classList.remove("overflow-hidden");
          this.$refs.results.classList.remove("overflow-auto");
          this.$refs.results.classList.add("overflow-hidden");
          this.setResultsHeight(val);
          setTimeout(() => {
            if (!this.active) {
              if (this.backdrop.parentElement) this.backdrop.parentElement.removeChild(this.backdrop);
              if (this.$refs.wrapper) this.$refs.wrapper.style.zIndex = "";
            }
          }, transitionDuration(this.backdrop) + 100);
        }
      }
    }
  },
  methods: {
    select(val) {
      this.setActive(false);
      setTimeout(() => {
        if (val.programCategoryId) this.$router.push({
          path: `/institutions/${val.entityId}/programs/${val.programCategoryId}`
        });else this.$router.push({
          path: `/institutions?entityId=${val.entityId}`
        });
      }, transitionDuration(this.$refs.results) + 50);
    },
    setActive(val) {
      if (val) this.active = true;else this.active = false;
    },
    setResultsHeight(isActive) {
      if (this.$refs.results) {
        const maxHeight = window.innerHeight - (this.$refs.results.offsetTop + 32);
        this.$refs.results.style.maxHeight = isActive == null && this.active || isActive ? maxHeight + "px" : "0";
      }
    },
    focus(e, query) {
      if (!e || e && e.target == document.querySelector(query)) this.$refs.input.focus();
    },
    search: debounce(function () {
      this.results = recursiveSearch({
        data: this.$store.getters.searchData,
        query: this.query,
        searchable: this.searchable,
        mode: this.mode,
        smartSearch: this.smartSearch,
        caseSensitive: this.caseSensitive
      });
      this.$refs.vList.scrollToIndex(0);
    }, 200)
  }
};